import { BaseModel } from "../../../vendor_core/core/src/model/BaseModel";
import { PointLike } from "../types/BURGameTypes";
import { ICascadeData } from "../types/IBURSpinModel";

class BURSpinModel extends BaseModel<ICascadeData> {
    private cascadesData: ICascadeData[] = [];
    private mysteryPositions: PointLike[] = [];
    private cascadeMysteryPositions: PointLike[] = [];
    private currentCascadeIndex: number = -1;
    private currentFreeSpinIndex: number = -1;
    private spinTotalWin: number = 0;

    public get cascades(): ICascadeData[] {
        return this.cascadesData;
    }

    /** The sum of the wins of all the cascades */
    public get cascades_total_win(): number {
        return this.cascadesData.reduce(
            (total, cascade) => total + cascade.creditsWon,
            0
        );
    }

    public get mystery_positions(): PointLike[] {
        return this.mysteryPositions;
    }
    public get cascade_mystery_positions(): PointLike[] {
        return this.cascadeMysteryPositions;
    }

    public get current_cascade_index(): number {
        return this.currentCascadeIndex;
    }

    public get current_free_spin_index(): number {
        return this.currentFreeSpinIndex;
    }

    public get spin_total_win(): number {
        return this.spinTotalWin;
    }

    public setCascades(payload: ICascadeData[]) {
        this.cascadesData = payload;
    }

    public setTotalWin(payload: number) {
        this.spinTotalWin = payload;
    }

    public setCurrentCascadeIndex(payload: number) {
        this.currentCascadeIndex = payload;
    }
    public setCurrentFreeSpinIndex(payload: number) {
        this.currentFreeSpinIndex = payload;
    }

    public setMysteryPositions(payload: PointLike[]) {
        this.mysteryPositions = payload;
    }
    public setCascadeMysteryPositions(payload: PointLike[]) {
        this.cascadeMysteryPositions = payload;
    }
}

export default new BURSpinModel();
